import { render, staticRenderFns } from "./ClinicTariffManage.vue?vue&type=template&id=02900581&scoped=true"
import script from "./ClinicTariffManage.vue?vue&type=script&lang=js"
export * from "./ClinicTariffManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02900581",
  null
  
)

export default component.exports